import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { StyledContent, StyledIcon } from './StyledSuccessModal';
import Heading from '../Heading';
import Modal from '../Modal';
import ModalContent from '../ModalContent';
var SuccessModal = function SuccessModal(_ref) {
  var duration = _ref.duration,
    message = _ref.message,
    show = _ref.show;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  useEffect(function () {
    if (show) {
      setIsOpen(true);
      setTimeout(function () {
        return setIsOpen(false);
      }, duration);
    }
  }, [duration, show]);
  return /*#__PURE__*/React.createElement(Modal, {
    open: isOpen,
    fullWidth: true,
    maxWidth: "sm",
    hideBackdrop: true
  }, /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(StyledContent, null, /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, null)), /*#__PURE__*/React.createElement(Heading, {
    align: "center",
    as: "h4",
    gutterBottom: false
  }, message))));
};
SuccessModal.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * How long modal should remain visible on screen
   */
  duration: PropTypes.number,
  /**
   * Message to display under the icon
   */
  message: PropTypes.string,
  /**
   * If `true`, then modal will be visible
   */
  show: PropTypes.bool
} : {};
SuccessModal.defaultProps = {
  duration: 1500,
  message: 'Saved!',
  show: false
};
export default SuccessModal;